import React, { useEffect, useState } from "react";
import AnimatedDigit from "./AnimatedDigit";
import countdownStyles from "../../../styles/countdown.module.css";
import style from "../../../styles/pujaDetails.module.css";
import { Divider, Typography } from "@mui/material";
import theme from "src/globalModule/styles/theme";
import Image from "next/legacy/image";
import Laddu from "@public/assets/icons/laddu_puja.svg";
import Video from "@public/assets/icons/hands.png";
import Star from "@public/assets/icons/star.png";
import { useTranslation } from "react-i18next";
function CountdownRenderer({
  days,
  hours,
  minutes,
  seconds,
  completed,
  avgRating
}) {
  const [prevTime, setPrevTime] = useState({
    days,
    hours,
    minutes,
    seconds
  });
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setPrevTime({
      days,
      hours,
      minutes,
      seconds
    });
  }, [days, hours, minutes, seconds]);
  const prevMinutes = String(prevTime.minutes).padStart(2, "0");
  const currentMinutes = String(minutes).padStart(2, "0");
  const prevSeconds = String(prevTime.seconds).padStart(2, "0");
  const currentSeconds = String(seconds).padStart(2, "0");
  return (
    // <div style={{ color: "red" }}>
    //   {days}:{hours}:{minutes}:{seconds}
    // </div>
    <>
      {days < 3 && !completed ? <div className={countdownStyles.timer}>
          <div className={countdownStyles.timerCard}>
            <div className={countdownStyles.timerDigit}>
              <AnimatedDigit value={String(days).padStart(2, "0")[0]} animate={prevTime.days !== days} />
              <AnimatedDigit value={String(days).padStart(2, "0")[1]} animate={prevTime.days !== days} />
            </div>
            <Typography sx={{
            color: theme.palette.primary.main,
            fontSize: "12px"
          }}>
              {t('days')}
            </Typography>
          </div>
          <div className={countdownStyles.colon}>:</div>
          <div className={countdownStyles.timerCard}>
            <div className={countdownStyles.timerDigit}>
              <AnimatedDigit value={String(hours).padStart(2, "0")[0]} animate={prevTime.hours !== hours} />
              <AnimatedDigit value={String(hours).padStart(2, "0")[1]} animate={prevTime.hours !== hours} />
            </div>
            <Typography sx={{
            color: theme.palette.primary.main,
            fontSize: "12px"
          }}>
              {t('hours')}
            </Typography>
          </div>
          <div className={countdownStyles.colon}>:</div>
          <div className={countdownStyles.timerCard}>
            <div className={countdownStyles.timerDigit}>
              <AnimatedDigit value={currentMinutes[0]} animate={prevMinutes[0] !== currentMinutes[0]} />
              <AnimatedDigit value={currentMinutes[1]} animate={prevMinutes[1] !== currentMinutes[1] || prevMinutes[0] !== currentMinutes[0]} />
            </div>
            <Typography sx={{
            color: theme.palette.primary.main,
            fontSize: "12px"
          }}>
              {t('min')}
            </Typography>
          </div>
          <div className={countdownStyles.colon}>:</div>
          <div className={countdownStyles.timerCard}>
            <div className={countdownStyles.timerDigit}>
              <AnimatedDigit value={currentSeconds[0]} animate={prevSeconds[0] !== currentSeconds[0]} />
              <AnimatedDigit value={currentSeconds[1]} animate={prevSeconds[1] !== currentSeconds[1] || prevSeconds[0] !== currentSeconds[0]} />
            </div>
            <Typography sx={{
            color: theme.palette.primary.main,
            fontSize: "12px"
          }}>
              {t('sec')}
            </Typography>
          </div>
        </div> : <div className={style.pujaFeatures}>
          <div className={style.featureHolder}>
            <Image src={Video} alt="image video" height={40} width={40} />
            <Typography fontSize={"15px"} mt={"5px"}>
              {t("watch")}
              <br />
              {t("puja-video")}
            </Typography>
          </div>

          <Divider orientation="vertical" variant="middle" flexItem sx={{
          color: theme.divider.backgroundColor,
          borderRightWidth: "1.5px",
          opacity: "0.5"
        }} />

          <div className={style.featureHolder}>
            <Laddu />
            <Typography fontSize={"15px"} mt={"5px"}>
              {t("prasad")}
              <br />
              {t("delivery")}
            </Typography>
          </div>

          <Divider orientation="vertical" variant="middle" flexItem sx={{
          color: theme.divider.backgroundColor,
          borderRightWidth: "1.5px",
          opacity: "0.5"
        }} />

          <div className={style.featureHolder}>
            <Image alt="star" src={Star} height={40} width={40} />
            <Typography fontSize={"15px"} mt={"5px"}>
              {avgRating} {` ${t("puja")}`}
              <br />
              {t("rating")}
            </Typography>
          </div>
        </div>}
    </>
  );
}
export default CountdownRenderer;